<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-menu-trigger variant="legacy" ariaLabel="Open menu"></app-menu-trigger>
    </ion-buttons>
    <ion-title style="color: var(--ion-color-title)"
      >{{'TRADING_CLUBS' | translate}}</ion-title
    >
    <ion-buttons slot="end" (click)="openModalAddGroup()">
      <ion-button class="add-button">
        <ion-icon
          slot="icon-only"
          name="add-circle"
          size="large"
          style="color: var(--ion-color-title)"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!--

      <ion-buttons end>
      <button ion-button block solid (click)="openModalAddGroup()" color="exmeNewDarkBlue">
        {{'CREATE_NEW_CLUB'|translate}}
      </button>
    </ion-buttons>

    <ion-buttons end>
      <button ion-button icon-only color="secondary" (click)="openModalAddGroup()">
        <ion-icon name="add"></ion-icon>
      </button>
    </ion-buttons>
  -->

  <ion-segment scrollable [(ngModel)]="groupView" (ionChange)="showData()">
    <ion-segment-button value="my" layout="icon-start">
      <ion-label>{{'MY_GROUPS' | translate}}</ion-label>
      <ion-badge
        *ngIf="totalPendinActionsMy > 0"
        color="primary"
        style="margin-left: 5px"
      >
        {{totalPendinActionsMy}}
      </ion-badge>
    </ion-segment-button>
    <ion-segment-button value="pending" layout="icon-start">
      <ion-label>{{'PENDING_PLURAL' | translate}}</ion-label>
      <ion-badge
        *ngIf="totalPendinActionsPending > 0"
        color="primary"
        style="margin-left: 5px"
      >
        {{totalPendinActionsPending}}
      </ion-badge>
    </ion-segment-button>
    <ion-segment-button value="publicG" layout="icon-start">
      <ion-label>{{'PUBLIC_GROUPS' | translate}}</ion-label>
    </ion-segment-button>
    <ion-segment-button value="privateG" layout="icon-start">
      <ion-label>{{'PRIVATE_GROUPS' | translate}}</ion-label>
    </ion-segment-button>
  </ion-segment>
</ion-header>

<ion-content #content nopadding>
  <ion-list *ngIf="groupView==='my'">
    <ion-searchbar
      placeholder="{{'SEARCH' | translate}}"
      (ionInput)="onInputMy($event)"
    ></ion-searchbar>

    <ion-card *ngFor="let myGroup of myGroupsList" style="position: relative">
      <ion-badge
        *ngIf="myGroup.numActionsPending > 0"
        class="notification-badge"
        color="primary"
        >{{myGroup.numActionsPending}}</ion-badge
      >

      <ion-item
        detail="false"
        lines="none"
        *ngIf="myGroup.STATUS === 3 || myGroup.STATUS === 4"
        (click)="navigateToClubMembers(myGroup)"
        class="club-container"
        style="contain: unset"
      >
        <ion-thumbnail slot="start" style="contain: unset">
          <img
            class="collection-thumbnail"
            src="{{myGroup.LOGO}}"
            onerror="if (this.src != 'assets/images/logo-noletter.svg') this.src = 'assets/images/logo-noletter.svg';"
          />
        </ion-thumbnail>
        <ion-label>
          <h2 class="ion-text-wrap white bold text-color">
            {{myGroup.Group_name}}
          </h2>
          <h3 class="white text-color">
            {{'MEMBERS' | translate}}: {{myGroup.GroupMembersCount.num_members}}
          </h3>
          <h3 text-wrap *ngIf="myGroup.STATUS === 3" class="white text-color">
            <ion-icon color="primary" name="checkmark-circle"></ion-icon>
            {{'ACTIVE' | translate}}
          </h3>
          <h3 text-wrap *ngIf="myGroup.STATUS === 4" class="white text-color">
            <ion-icon color="primary" name="settings"></ion-icon>
            {{'ADMIN' | translate}}
          </h3>
          <p class="ion-text-wrap" style="color: var(--ion-color-gray-white)">
            {{myGroup.GROUP_DESCRIPTION}}
          </p>
        </ion-label>
      </ion-item>
    </ion-card>
  </ion-list>

  <ion-list *ngIf="groupView==='pending'">
    <ion-searchbar
      placeholder="{{'SEARCH' | translate}}"
      (ionInput)="onInputMy($event)"
    ></ion-searchbar>
    <ng-container *ngFor="let myGroup of myGroupsList">
      <ion-card *ngIf="myGroup.STATUS === 1 || myGroup.STATUS === 2">
        <ion-item (click)="processClick(myGroup)">
          <ion-thumbnail slot="start">
            <img
              class="collection-thumbnail"
              src="{{myGroup.LOGO}}"
              onerror="if (this.src != 'assets/images/logo-noletter.svg') this.src = 'assets/images/logo-noletter.svg';"
            />
          </ion-thumbnail>
          <ion-label>
            <h2 class="ion-text-wrap white bold text-color">
              {{myGroup.Group_name}}
            </h2>
            <h3 class="white text-color">
              {{'MEMBERS' | translate}}:
              {{myGroup.GroupMembersCount.num_members}}
            </h3>
            <h3 class="ion-text-wrap white text-color">
              <ion-icon color="exme-red-light" name="alert"></ion-icon>
              {{'PENDING' | translate}}
            </h3>
            <p class="ion-text-wrap" style="color: var(--ion-color-gray-white)">
              {{myGroup.GROUP_DESCRIPTION}}
            </p>
          </ion-label>
          <ion-badge
            *ngIf="myGroup.numActionsPending > 0"
            slot="end"
            color="exme-red-light"
            >{{myGroup.numActionsPending}}</ion-badge
          >
        </ion-item>
      </ion-card>
    </ng-container>
  </ion-list>

  <ion-list *ngIf="groupView==='publicG'">
    <ion-searchbar
      placeholder="{{'SEARCH' | translate}}"
      (ionInput)="onInputPub($event)"
    ></ion-searchbar>

    <ion-item>
      <!--
      <ion-label>{{'COLLECTIONS_FROM' | translate }}</ion-label>
      -->
      <ion-select
        slot="end"
        [(ngModel)]="selectedCountryPub"
        (ionChange)="onChangeCountryPub()"
        interface="popover"
      >
        <ion-select-option value="All"
          >{{'ALL' | translate }}</ion-select-option
        >
        <ion-select-option
          *ngFor="let country of collectionCountries"
          value="{{country.country_code}}"
          >{{country.country_name}}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-card *ngFor="let publicGroup of pubList">
      <ion-item lines="none" (click)="processClick(publicGroup)">
        <ion-thumbnail slot="start">
          <img
            class="collection-thumbnail"
            src="{{publicGroup.LOGO}}"
            onerror="if (this.src != 'assets/images/logo-noletter.svg') this.src = 'assets/images/logo-noletter.svg';"
          />
        </ion-thumbnail>
        <ion-label>
          <h2 class="ion-text-wrap white bold text-color">
            {{publicGroup.Group_name}}
          </h2>
          <h3
            *ngIf="publicGroup.GroupMembersCount!== undefined"
            class="white text-color"
          >
            {{'MEMBERS' | translate}}:
            {{publicGroup.GroupMembersCount.num_members}}
          </h3>
          <p class="ion-text-wrap" style="color: var(--ion-color-gray-white)">
            {{publicGroup.GROUP_DESCRIPTION}}
          </p>
        </ion-label>
      </ion-item>
    </ion-card>
  </ion-list>

  <ion-list *ngIf="groupView==='privateG'">
    <ion-searchbar
      placeholder="{{'SEARCH' | translate}}"
      (ionInput)="onInputPri($event)"
    ></ion-searchbar>

    <ion-item>
      <!--
      <ion-label>{{'COLLECTIONS_FROM' | translate }}</ion-label>
      -->
      <ion-select
        slot="end"
        [(ngModel)]="selectedCountry"
        (ionChange)="onChangeCountryPri()"
        interface="popover"
      >
        <ion-select-option value="All"
          >{{'ALL' | translate }}</ion-select-option
        >
        <ion-select-option
          *ngFor="let country of collectionCountries"
          value="{{country.country_code}}"
          >{{country.country_name}}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <!--ion-item-divider color="light">{{'PRIVATE_GROUPS' | translate}}</ion-item-divider-->
    <ion-card *ngFor="let privateGroup of priList">
      <ion-item lines="none" (click)="processClickPrivate(privateGroup)">
        <ion-thumbnail slot="start">
          <img
            class="collection-thumbnail"
            src="{{privateGroup.LOGO}}"
            onerror="if (this.src != 'assets/images/logo-noletter.svg') this.src = 'assets/images/logo-noletter.svg';"
          />
        </ion-thumbnail>
        <ion-label>
          <h2 class="ion-text-wrap white bold text-color">
            {{privateGroup.Group_name}}
          </h2>
          <h3 class="white text-color">
            {{'MEMBERS' | translate}}:
            {{privateGroup.GroupMembersCount.num_members}}
          </h3>
          <p class="ion-text-wrap" style="color: var(--ion-color-gray-white)">
            {{privateGroup.GROUP_DESCRIPTION}}
          </p>
        </ion-label>
      </ion-item>
    </ion-card>
  </ion-list>
</ion-content>
